import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-full',
    templateUrl: './full.component.html',
    styleUrls: ['./full.component.scss'],
    standalone: false
})
export class FullComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
